import { CornerDownRight } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

export const InsertIndicator = () => (
  <TooltipProvider delayDuration={0}>
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="shrink-0 inline-flex items-center text-amber-600">
          <CornerDownRight className="h-4 w-4" />
        </span>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[240px] text-xs font-normal z-100000">
        Insert: numbered as decimal sub-pages of the preceding page (e.g. 317.01, 317.02…) without shifting the main pagination.
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
